import { h } from 'vue'
import { RouterView } from 'vue-router'

export default [
  {
    path: '/:lang/membership', // 支持语言前缀
    component: { render: () => h(RouterView) },
    meta: {
      defaultName: 'MemberShip',
      name: 'home.header.Member.name',
      weight: 1,
    },
    children: [
      {
        path: '/:lang/membership/list', // 相对路径
        name: 'membershipList',
        meta: {
          middleware: ['scroll-top'],
          defaultName: 'Company Directory',
          name: 'home.header.CompanyDirectory',
          pageCode: 'ERA.UC.MEMBERSHIP',
          noPc: true,
        },
        component: () => import('@/pages/membership/baseList.vue'),
      },
      {
        path: '/:lang/membership/list/:advantageType-:memberType', // 相对路径
        name: 'membershipListAd',
        meta: {
          middleware: ['scroll-top'],
          headerStyle: 'normal',
          pageCode: 'ERA.UC.MEMBERSHIP.ADVAN',
          noPc: true,
        },
        component: () => import('~/pages/membership/baseList.vue'),
      },
      {
        path: '/:lang/membership/listc/:countryName/:advantageType-:memberType', // 相对路径
        name: 'membershipListC',
        meta: {
          middleware: ['scroll-top'],
          headerStyle: 'normal',
          pageCode: 'ERA.UC.MEMBERSHIP.COUNTRY',
          noPc: true,
        },
        component: () => import('~/pages/membership/baseList.vue'),
      },
      {
        path: '/:lang/membership/listp/:portName/:advantageType-:memberType', // 相对路径
        name: 'membershipListP',
        meta: {
          middleware: ['scroll-top'],
          headerStyle: 'normal',
          pageCode: 'ERA.UC.MEMBERSHIP.PORT',
          noPc: true,
        },
        component: () => import('~/pages/membership/baseList.vue'),
      },
      {
        path: '/:lang/company/list', // 相对路径
        name: 'companyList',
        meta: {
          middleware: ['scroll-top'],
          defaultName: 'Company Directory',
          name: 'home.header.CompanyDirectory',
          pageCode: 'ERA.UC.COMPANY',
        },
        component: () => import('@/pages/membership/baseList.vue'),
      },
      {
        path: '/:lang/company/list/:advantageType-:memberType', // 相对路径
        name: 'companyListAd',
        meta: {
          middleware: ['scroll-top'],
          headerStyle: 'normal',
          pageCode: 'ERA.UC.COMPANY.ADVAN',
          noPc: true,
        },
        component: () => import('~/pages/membership/baseList.vue'),
      },
      {
        path: '/:lang/company/listc/:countryName/:advantageType-:memberType', // 相对路径
        name: 'companyListC',
        meta: {
          middleware: ['scroll-top'],
          headerStyle: 'normal',
          pageCode: 'ERA.UC.COMPANY.COUNTRY',
          noPc: true,
        },
        component: () => import('~/pages/membership/baseList.vue'),
      },
      {
        path: '/:lang/company/listp/:portName/:advantageType-:memberType', // 相对路径
        name: 'companyListP',
        meta: {
          middleware: ['scroll-top'],
          headerStyle: 'normal',
          pageCode: 'ERA.UC.COMPANY.PORT',
          noPc: true,
        },
        component: () => import('~/pages/membership/baseList.vue'),
      },
      // --- Start: 新 SEO 路由配置 (替换原有的 company/list 相关路由) ---

      // 1. 基础入口 (对应 company/)
      // 匹配: /en/company 或 /cn/company
      {
        path: '/:lang/company/',
        name: 'companyListBase',
        meta: {
          middleware: ['scroll-top'],
          headerStyle: 'normal',
          pageCode: 'ERA.UC.MEMBERSHIP',
          defaultName: 'Company Directory',
          name: 'home.header.CompanyDirectory',
        },
        component: () => import('~/pages/membership/list.vue'),
      },

      // 2. 仅翻页 (对应 company-page-2/)
      // 正则约束: page 必须是数字，避免与 country 混淆
      {
        path: '/:lang/company-page-:page(\\d+)/',
        name: 'companyListPage',
        meta: {
          middleware: ['scroll-top'],
          headerStyle: 'normal',
          pageCode: 'ERA.UC.COMPANY.PAGE',
        },
        component: () => import('~/pages/membership/list.vue'),
      },

      // 3. 国家 + 翻页 (对应 company-China-page-2/)
      // country 部分捕获直到 -page- 之前的内容
      {
        path: '/:lang/company-:country-page-:page(\\d+)/',
        name: 'companyListCountryPage',
        meta: {
          middleware: ['scroll-top'],
          headerStyle: 'normal',
          pageCode: 'ERA.UC.COMPANY.COUNTRY_PAGE',
        },
        component: () => import('~/pages/membership/list.vue'),
      },

      // 4. 仅国家 (对应 company-China/)
      // 注意：这个规则放在带 page 的规则之后，作为兜底匹配非 page 的后缀
      {
        path: '/:lang/company-:country/',
        name: 'companyListCountry',
        meta: {
          middleware: ['scroll-top'],
          headerStyle: 'normal',
          pageCode: 'ERA.UC.COMPANY.COUNTRY',
        },
        component: () => import('~/pages/membership/list.vue'),
      },

      // --- End: 新 SEO 路由配置 ---

      {
        name: 'membershipJCTransBenefitsOverview',
        path: '/:lang/vip-benefits/',
        meta: {
          name: 'home.header.Member.MembershipIntroduction',
          pageCode: 'ERA.UC.MEMBERSHIP.BO',
          noPc: true,
        },
        component: () => import('@/pages/membership/introduction.vue'),
      },
      {
        name: 'membershipJCTransIntroduction',
        path: '/:lang/vip/',
        meta: {
          name: 'home.header.Member.MembershipIntroduction',
          pageCode: 'ERA.UC.MEMBERSHIP.MI',
          headerIsWhite: true,
        },
        component: () => import('@/pages/membership/introduction.vue'),
      },
      {
        name: 'membershipJCVF',
        path: '/:lang/JCVerified/',
        meta: {
          name: 'home.header.Member.MembershipJCVF',
          pageCode: 'ERA.UC.MEMBERSHIP.JCVerified',
          headerIsWhite: false,
        },
        component: () => import('@/pages/membership/jcvf.vue'),
      },
    ],
  },
  // 以下是风控相关
  {
    name: 'CooperativeGuarantee',
    path: '/:lang/membership/tools',
    component: { render: () => h(RouterView) },
    meta: {
      name: 'header.cooperativeGuarantee.cooperative_guarantee',
      icon: 'NavMemberTools',
      weight: 5,
      defaultName: 'CooperativeGuarantee',
    },
    redirect: { name: 'membershipToolsRisk' },
    children: [
      // 风控 - black名单列表页 risk member list
      {
        path: '/:lang/membership/tools/risk/blackList',
        name: 'membershipToolsBlackList',
        component: () => import('@/pages/BlackNew/BlackList.vue'),
        meta: {
          headerStyle: 'normal', // header 样式
          pageCode: 'ERA.UC.TOOLS.BLACK.BLACKLIST',
          loginDialog: true,
          loginSeconds: 20,
          loginDesCn: '登录后，可查看更多企业的风险详情！',
          loginDesEn: 'Sign in to view more risk details!',
          clickSource: 'PLT.REG.H5.H5_ERA_RISK_LIST_VIEW_SECONDS',
          appClickSource: 'PLT.REG.APP.APP_ERA_RISK_LIST_VIEW_SECONDS',
        },
      },
      // 黑名单公司详情页
      {
        path: '/:lang/membership/tools/black/:compId',
        name: 'membershipToolsBlackDetail',
        component: () => import('@/pages/BlackNew/Black/detail.vue'),
        meta: {
          middleware: ['scroll-top'],
          headerStyle: 'normal', // header 样式
          pageCode: 'ERA.UC.TOOLS.BLACK.DETAIL',
        },
      },

      // 保障介绍 规则说明 Assurance
      {
        path: '/:lang/membership/tools/assurance/process',
        name: 'assuranceIntroductionProcess',
        component: () =>
          import('@/pages/BlackNew/Assurance/riskAssuranceProcess.vue'),
        meta: {
          headerStyle: 'normal', // header 样式
          pageCode: 'ERA.UC.TOOLS.RiskAssurance.ProcessIntroduction',
        },
      },
      {
        path: '/:lang/membership/tools/risk/assuranceIntroductionProcess/detail/:id',
        name: 'membershipToolsRiskProcessDetail',
        component: () =>
          import('@/pages/BlackNew/Assurance/AssuranceProcessDetail.vue'),
        meta: {
          headerStyle: 'normal', // header 样式
          pageCode: 'ERA.UC.TOOLS.RISK.PROCESS.DETAIL',
        },
      },
      // 保障介绍 问题 回答
      {
        path: '/:lang/membership/tools/assurance/question',
        name: 'assuranceIntroductionQuestion',
        component: () =>
          import('@/pages/BlackNew/Assurance/riskAssuranceQuestion.vue'),
        meta: {
          headerStyle: 'normal', // header 样式
          pageCode: 'ERA.UC.TOOLS.RiskAssurance.Question',
        },
      },
      // 保障介绍 热点
      {
        path: '/:lang/membership/tools/assurance/topics',
        name: 'assuranceIntroductionTopic',
        component: () =>
          import('@/pages/BlackNew/Assurance/riskAssuranceTopic.vue'),
        meta: {
          headerStyle: 'normal', // header 样式
          pageCode: 'ERA.UC.TOOLS.RiskAssurance.HotTopics',
        },
      },
      // 保障介绍 赔付标准
      {
        path: '/:lang/membership/tools/compensation/standards',
        name: 'compensationStandards',
        component: () => import('@/pages/BlackNew/Assurance/riskStandards.vue'),
        meta: {
          headerStyle: 'normal', // header 样式
          pageCode: 'ERA.UC.TOOLS.RiskAssurance.CompensationStandards',
        },
      },

      // 风险防范  案例解析 Prevention
      {
        path: '/:lang/membership/tools/riskPrevention/case',
        name: 'riskPreventionRiskCase',
        component: () => import('@/pages/BlackNew/Prevention/riskCase.vue'),
        meta: {
          headerStyle: 'normal', // header 样式
          pageCode: 'ERA.UC.TOOLS.RiskPrevention.RiskCase',
        },
      },

      // 风险防范  风险分享 Prevention
      {
        path: '/:lang/membership/tools/riskPrevention/sharing',
        name: 'riskPreventionRiskSharing',
        component: () => import('@/pages/BlackNew/Prevention/riskSharing.vue'),
        meta: {
          headerStyle: 'normal', // header 样式
          pageCode: 'ERA.UC.TOOLS.RiskPrevention.RiskSharing',
        },
      },
      // 风险防范  风险分享详情页
      {
        path: '/:lang/membership/tools/risk/video/detail/:id',
        name: 'riskPreventionRiskSharingDetail_OLD',
        component: () =>
          import('@/pages/BlackNew/Prevention/SharingDetail.vue'),
        meta: {
          headerStyle: 'normal', // header 样式
          pageCode: 'ERA.UC.TOOLS.RiskPrevention.RiskSharingDetail',
          noPc: true,
        },
      },
      {
        path: '/:lang/membership/tools/risk/riskPreventionRiskSharing/:id',
        name: 'riskPreventionRiskSharingDetail',
        component: () =>
          import('@/pages/BlackNew/Prevention/SharingDetail.vue'),
        meta: {
          headerStyle: 'normal', // header 样式
          pageCode: 'ERA.UC.TOOLS.RISK.VIDEO.DETAIL',
        },
      },

      // 风险防范  风险通知 Prevention
      {
        path: '/:lang/membership/tools/riskPrevention/notice',
        name: 'riskPreventionRiskNotice',
        component: () => import('@/pages/BlackNew/Prevention/riskNotice.vue'),
        meta: {
          headerStyle: 'normal', // header 样式
          pageCode: 'ERA.UC.TOOLS.RiskPrevention.RiskNotice',
        },
      },
      // 风险防范  案例解析详情页
      {
        path: '/:lang/membership/tools/risk/detail/:id',
        name: 'riskPreventionRiskCaseDetail_OLD',
        component: () => import('@/pages/BlackNew/Prevention/CaseDetail.vue'),
        meta: {
          headerStyle: 'normal', // header 样式
          pageCode: 'ERA.UC.TOOLS.RiskPrevention.CaseDetail',
          noPc: true,
        },
      },
      {
        path: '/:lang/membership/tools/risk/case/detail/:id',
        name: 'riskPreventionRiskCaseDetail_CASE',
        component: () => import('@/pages/BlackNew/Prevention/CaseDetail.vue'),
        meta: {
          headerStyle: 'normal', // header 样式
          pageCode: 'ERA.UC.TOOLS.RiskPrevention.CaseDetail',
          noPc: true,
        },
      },
      {
        path: '/:lang/membership/tools/risk/riskPreventionRiskCase/detail/:id',
        name: 'riskPreventionRiskCaseDetail',
        component: () => import('@/pages/BlackNew/Prevention/CaseDetail.vue'),
        meta: {
          headerStyle: 'normal', // header 样式
          pageCode: 'ERA.UC.TOOLS.RISK.DETAIL',
        },
      },

      // 风险防范  风险通知详情页
      {
        path: '/:lang/membership/tools/risk/detail/:id',
        name: 'riskPreventionRiskNoticeDetail_OLD',
        component: () => import('@/pages/BlackNew/Prevention/NoticeDetail.vue'),
        meta: {
          headerStyle: 'normal', // header 样式
          pageCode: 'ERA.UC.TOOLS.RiskPrevention.RiskNoticeDetail',
          noPc: true,
        },
      },
      {
        path: '/:lang/membership/tools/risk/notice/detail/:id',
        name: 'riskPreventionRiskNoticeDetail_NOTICE',
        component: () => import('@/pages/BlackNew/Prevention/NoticeDetail.vue'),
        meta: {
          headerStyle: 'normal', // header 样式
          pageCode: 'ERA.UC.TOOLS.RiskPrevention.RiskNoticeDetail',
          noPc: true,
        },
      },
      {
        path: '/:lang/membership/tools/risk/riskPreventionRiskNotice/detail/:id',
        name: 'riskPreventionRiskNoticeDetail',
        component: () => import('@/pages/BlackNew/Prevention/NoticeDetail.vue'),
        meta: {
          headerStyle: 'normal', // header 样式
          pageCode: 'ERA.UC.TOOLS.RISK.NOTICE.DETAIL',
        },
      },
    ],
  },

  // 以下是八个会员介绍页
  // {
  //   path: '/:lang/membership/general',
  //   component: { render: () => h(RouterView) },
  //   meta: {
  //     defaultName: 'MemberShipGeneral',
  //     name: 'home.header.Member.GeneralMembership',
  //     weight: 1,
  //   },
  //   children: [
  //     {
  //       name: 'membershipJCTransElite',
  //       path: 'elite_old',
  //       meta: {
  //         name: 'home.header.Member.JCElite',
  //         pageCode: 'ERA.UC.MEMBERSHIP.JCE',
  //         headerIsWhite: true,
  //         applyMember: true,
  //         middleware: ['scroll-top'],
  //       },
  //       component: () => import('@/pages/membership/general/elite.vue'),
  //     },
  //     {
  //       name: 'membershipJCTransPremium',
  //       path: 'premium_old',
  //       meta: {
  //         name: 'home.header.Member.JCPremium',
  //         pageCode: 'ERA.UC.MEMBERSHIP.JCP',
  //         headerIsWhite: true,
  //         applyMember: true,
  //         middleware: ['scroll-top'],
  //       },
  //       component: () => import('@/pages/membership/general/premium.vue'),
  //     },
  //     {
  //       name: 'membershipJCTransRising',
  //       path: 'rising_old',
  //       meta: {
  //         name: 'home.header.Member.JCRising',
  //         pageCode: 'ERA.UC.MEMBERSHIP.JCRI',
  //         headerIsWhite: true,
  //         applyMember: true,
  //         middleware: ['scroll-top'],
  //       },
  //       component: () => import('@/pages/membership/general/rising.vue'),
  //     },
  //     // 以下为新
  {
    name: 'membershipJCTransEliteNew',
    path: '/:lang/vip-elite/',
    meta: {
      name: 'home.header.Member.JCElite',
      pageCode: 'ERA.UC.MEMBERSHIP.JCE',
      headerIsWhite: true,
      applyMember: true,
      middleware: ['scroll-top'],
    },
    component: () => import('@/pages/membership/general/eliteNew.vue'),
  },
  {
    name: 'membershipJCTransPremiumNew',
    path: '/:lang/vip-premium/',
    meta: {
      name: 'home.header.Member.JCPremium',
      pageCode: 'ERA.UC.MEMBERSHIP.JCP',
      headerIsWhite: true,
      applyMember: true,
      middleware: ['scroll-top'],
    },
    component: () => import('@/pages/membership/general/premiumNew.vue'),
  },
  {
    name: 'membershipJCTransRisingNew',
    path: '/:lang/vip-rising/',
    meta: {
      name: 'home.header.Member.JCRising',
      pageCode: 'ERA.UC.MEMBERSHIP.JCRI',
      headerIsWhite: true,
      applyMember: true,
      middleware: ['scroll-top'],
    },
    component: () => import('@/pages/membership/general/risingNew.vue'),
  },
  //   ],
  // },

  {
    path: '/:lang/membership/specialty',
    name: 'membershipSpecialtyMemberships',
    component: { render: () => h(RouterView) },
    meta: {
      name: 'home.header.Member.SpecialtyMemberships',
    },
    children: [
      {
        name: 'membershipJCTransProjectsAbout',
        path: 'projects_old',
        meta: {
          name: 'home.header.Member.JCProject',
          pageCode: 'ERA.UC.MEMBERSHIP.JCTP',
          headerIsWhite: true,
          applyMember: true,
          middleware: ['scroll-top'],
        },
        component: () => import('@/pages/membership/specialty/projects.vue'),
      },
      {
        name: 'membershipJCTransDangerousGoodsAbout',
        path: 'dangerous_old',
        meta: {
          name: 'home.header.Member.JCDangerousGoods',
          pageCode: 'ERA.UC.MEMBERSHIP.JCTD',
          headerIsWhite: true,
          applyMember: true,
          middleware: ['scroll-top'],
        },
        component: () => import('@/pages/membership/specialty/dangerous.vue'),
      },
      {
        name: 'membershipJCTransECommerceAbout',
        path: 'commerce_old',
        meta: {
          name: 'home.header.Member.JCeCommerce',
          pageCode: 'ERA.UC.MEMBERSHIP.JCEC',
          headerIsWhite: true,
          applyMember: true,
          middleware: ['scroll-top'],
        },
        component: () => import('@/pages/membership/specialty/commerce.vue'),
      },
      {
        name: 'membershipJCTransRailwayAbout',
        path: 'railway_old',
        meta: {
          name: 'home.header.Member.JCRailway',
          pageCode: 'ERA.UC.MEMBERSHIP.JCR',
          headerIsWhite: true,
          applyMember: true,
          middleware: ['scroll-top'],
        },
        component: () => import('@/pages/membership/specialty/railway.vue'),
      },
      // yixia 为新
      {
        name: 'membershipJCTransProjectsAboutNew',
        path: '/:lang/vip-projects/',
        meta: {
          name: 'home.header.Member.JCProject',
          pageCode: 'ERA.UC.MEMBERSHIP.JCTP',
          headerIsWhite: true,
          applyMember: true,
          middleware: ['scroll-top'],
        },
        component: () => import('@/pages/membership/specialty/projectsNew.vue'),
      },
      {
        name: 'membershipJCTransDangerousGoodsAboutNew',
        path: '/:lang/vip-dangerous/',
        meta: {
          name: 'home.header.Member.JCDangerousGoods',
          pageCode: 'ERA.UC.MEMBERSHIP.JCTD',
          headerIsWhite: true,
          applyMember: true,
          middleware: ['scroll-top'],
        },
        component: () =>
          import('@/pages/membership/specialty/dangerousNew.vue'),
      },
      {
        name: 'membershipJCTransECommerceAboutNew',
        path: '/:lang/vip-commerce/',
        meta: {
          name: 'home.header.Member.JCeCommerce',
          pageCode: 'ERA.UC.MEMBERSHIP.JCEC',
          headerIsWhite: true,
          applyMember: true,
          middleware: ['scroll-top'],
        },
        component: () => import('@/pages/membership/specialty/commerceNew.vue'),
      },
      {
        name: 'membershipJCTransRailwayAboutNew',
        path: '/:lang/vip-railway/',
        meta: {
          name: 'home.header.Member.JCRailway',
          pageCode: 'ERA.UC.MEMBERSHIP.JCR',
          headerIsWhite: true,
          applyMember: true,
          middleware: ['scroll-top'],
        },
        component: () => import('@/pages/membership/specialty/railwayNew.vue'),
      },
    ],
  },
  {
    name: 'membershipSupplierMemberships',
    path: '/:lang/membership/supplier',
    component: { render: () => h(RouterView) },
    meta: {
      name: 'home.header.Member.SupplierMemberships',
      icon: 'NavMemberSupplier',
    },
    children: [
      {
        name: 'membershipJCTransVendor',
        path: 'vendor_old',
        meta: {
          name: 'home.header.Member.JCVendor',
          oldname: 'JC Vendor',
          pageCode: 'ERA.UC.MEMBERSHIP.JCV',
          headerIsWhite: true,
          applyMember: true,
          middleware: ['scroll-top'],
        },
        component: () => import('@/pages/membership/supplier/vendor.vue'),
      },
      // yixia 为新
      {
        name: 'membershipJCTransVendorNew',
        path: '/:lang/vip-vendor/',
        meta: {
          name: 'home.header.Member.JCVendor',
          oldname: 'JC Vendor',
          pageCode: 'ERA.UC.MEMBERSHIP.JCV',
          headerIsWhite: true,
          applyMember: true,
          middleware: ['scroll-top'],
        },
        component: () => import('@/pages/membership/supplier/vendorNew.vue'),
      },
    ],
  },
]
